import Semaphore from "./Semaphore";

export default Semaphore;
